var cpmURL = 'https://hxom9phqm0.execute-api.eu-west-1.amazonaws.com/ops/';
var cpmKey = 'UXfY6upsHQ6WBzCAzhPGQ1sFaydNgTJa7CGFYVX2';
var lang = 'es';
var $stepOne, $stepTwo, $notifications, $loading;
var email, action;

var hostTokens = window.location.hostname.split('.');

if(hostTokens[0] == 'www' && hostTokens[1] == 'esendex') {
    cpmURL = 'https://uzyqz0bpi4.execute-api.eu-west-1.amazonaws.com/production/';
    cpmKey = 'VuUta0EYtG5Hd4jxBgQXH7mFOiRPD70p2X299ZRF';
}

document.addEventListener("DOMContentLoaded", function() {
    setCopy();
    $loading = document.getElementById('loading');
    $stepOne = document.getElementById('step-one');
    $stepTwo = document.getElementById('step-two');
    $notifications = document.getElementById('notifications');

    email = getQueryVariable('email');
    action = getQueryVariable('action');

    if(email && email.replace(' ', '').length > 0) {
        email = decodeURIComponent(email);
        if(action && action.replace(' ', '').length > 0) {
            if(action == 'subscribe') {
                console.log('subscribing');
                setPreferencesFull(email, (error) => {
                    if(!error) {
                        showNotification('success', Strings[lang].notifySubscribe);
                        proceed();
                    } else {
                        showNotification('success', Strings[lang].notifySetError(email));
                        proceed();
                    }
                });
            } else if(action == 'unsubscribe') {
                console.log('unsubscribing');
                setPreferencesEmpty(email, (error) => {
                    if(!error) {
                        showNotification('success', Strings[lang].notifyUnsubscribe);
                        proceed();
                    } else {
                        showNotification('success', Strings[lang].notifySetError(email));
                        proceed();
                    }
                });
            } 
        }

        function proceed() {
            getPreferences(email, (error, preferences) => {
                if(!error) {
                    stepTwo(email, preferences);
                } else {
                    console.log(error);
                    if(error.status == 400) {
                        showNotification('danger', Strings[lang].notifyInvalidEmail(email));
                    } else {
                        showNotification('danger', Strings[lang].notifyGetError(email));
                    }
                    stepOne();
                }
            });
        }

        proceed();
    } else {
        stepOne();
    }
});

function stepOne() {
    var $emailField = $stepOne.querySelector('#field-email');
    var $emailSubmit = $stepOne.querySelector('#submit-email');

    $stepOne.className = "";
    $stepTwo.className = "d-none";
    $loading.className = "d-none";

    $emailSubmit.onclick = function(e) {
        e.preventDefault();
        email = $emailField.value;
        $emailSubmit.innerHTML = Strings[lang].buttonLoading;
        clearNotification();

        getPreferences(email, (error, preferences) => {
            if(!error) {
                stepTwo(email, preferences);
            } else {
                if(error.status == 400) { 
                    showNotification('danger', Strings[lang].notifyInvalidEmail(email));
                } else {
                    showNotification('danger', Strings[lang].notifyGetError(email));
                }

                $emailSubmit.innerHTML = Strings[lang].buttonProceed;
            }
        });

        return false;
    };
}

function stepTwo(email, inputPreferences) {
    var preferences = Object.assign({}, inputPreferences)
    var $emailText = $stepTwo.querySelector('#text-email span');
    var $subscribeButton = $stepTwo.querySelector('#preferences-subscribe');
    var $unsubscribeButton = $stepTwo.querySelector('#preferences-unsubscribe');
    var $saveButton = $stepTwo.querySelector('#preferences-save');

    $stepOne.className = "d-none";
    $loading.className = "d-none";
    $stepTwo.className = "";

    $emailText.innerHTML = email;

    var empty = true;

    Object.keys(preferences).forEach((channel) => {
        var $checkbox = $stepTwo.querySelector(`#checkbox-${channel}`);
        if(preferences[channel] == true) {
            $checkbox.checked = true;
            empty = false;
        } else {
            $checkbox.checked = false;
        }
        $checkbox.onclick = function(e) {
            clearNotification();
            preferences[channel] = !preferences[channel];
        };
    });

    function disableButtons() {
        $subscribeButton.disabled = true;
        $unsubscribeButton.disabled = true;
        $saveButton.disabled = true;
    }

    function enableButtons() {
        $subscribeButton.disabled = false;
        $unsubscribeButton.disabled = false;
        $saveButton.disabled = false;
    }

    $subscribeButton.onclick = function(e) {
        this.innerHTML = Strings[lang].buttonLoading;
        disableButtons();
        setPreferencesFull(email, (error) => {
            if(!error) {
                showNotification('success', Strings[lang].notifySubscribe);
            } else {
                showNotification('success', Strings[lang].notifySetError(email));
            }
            this.innerHTML = Strings[lang].buttonSubscribe;
            enableButtons();
            stepTwo(email, Preferences.full);
        });
    };

    $unsubscribeButton.onclick = function(e) {
        this.innerHTML = Strings[lang].buttonLoading;
        disableButtons();
        setPreferencesEmpty(email, (error) => {
            if(!error) {
                showNotification('success', Strings[lang].notifyUnsubscribe);
            } else {
                showNotification('success', Strings[lang].notifySetError(email));
            }
            this.innerHTML = Strings[lang].buttonUnsubscribe;
            enableButtons();
            stepTwo(email, Preferences.empty);
        });
    };

    $saveButton.onclick = function(e) {
        this.innerHTML = Strings[lang].buttonLoading;
        disableButtons();
        setPreferences(email, preferences, (error) => {
            if(!error) {
                showNotification('success', Strings[lang].notifySetSuccess);
            } else {
                showNotification('success', Strings[lang].notifySetError(email));
            }
            this.innerHTML = Strings[lang].buttonSave;
            enableButtons();
            stepTwo(email, preferences);
        });
    };

    if(empty && action !== 'unsubscribe' && $notifications.children.length == 0) {
        showNotification('info', Strings[lang].notifyEmptyPreferences(email));
    }
}
